<script>
	// From Lucide
	import { Info } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Info class={iconClass} />
